'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        textColor: {
            type: String,
            default: undefined,
            kComposite: 'text.color'
        },
        textFont: {
            type: String,
            default: undefined,
            kComposite: 'text.font'
        },
        textMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'text.margin.bottom'
        },
        textMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'text.margin.left'
        },
        textMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'text.margin.right'
        },
        textMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'text.margin.top'
        },
        textVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'text.visible'
        }
    }
};